<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesPrdPpComponentResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      withCustomRowActions
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #customRowActions="{row}">
                                    <b-button-group>
                                        <em-button type="gotoSdr" v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   @click="gotoSdr(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author Shi Wen Long
// Date 2021-10-18 11:57:25

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import emCommonGotoMixin from "@/mixin/em/common/goto";

export default {
    name: "sithMesPrdPpComponentListView",
    mixins: [emCommonListMixin, emCustomVuexMixin, emCommonGotoMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    methods: {
        //从组件信息页面跳转到SDR管理页面
        gotoSdr(row) {
            this.$_emGotoMixin_gotoHolderList(
                "sithMesStoolPoSdr",
                {poNumberFilter: row.po, itemNumberFilter: row.poItem},
                {poNumber: row.po, itemNumber: row.poItem},
                false,
                {pathType: "list"},
                undefined,
                undefined,
                undefined,
                "sithMesStoolPoSdrEngineerList"
            );
        },
    },
    mounted() {

        let operationId = this.$route.query.operationId;
        if (operationId) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('operationIdFilter', operationId);
        }
        let material = this.$route.query.material;
        if (material) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('materialNumberFilter', material);
        }
        if (this.$route.query.orderNumber) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('orderNumberFilter', this.$route.query.orderNumber);
        }
        this.$refs["emListFilter"].doQuery();

    }
};
</script>